import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  contingentModule,
  exportFincenterZIP,
  loadFincenterDocuments
} from '../ContingentPage/ContingentDucks';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import paths from '../../_helpers/paths';
import { useTranslation } from 'react-i18next';
import { reportsRegistryColumn } from './ReportsRegistryColumn';


const ReportsRegistryPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { finCenterDocuments, loadingFinCenterDocuments } = useSelector(
    state => state[contingentModule]
  );
  const { nextPage } = useTableFilter(
    filter => dispatch(loadFincenterDocuments(filter)),
    {
      pageNumber: 1,
      pageSize: 10,
      status: 'SENT',
      type: 'FINCENTER_VOUCHER_REPORT'
    },
    'reportsPage'
  );

  const handleDownloadZip = (documentId, fileName) => {
    dispatch(exportFincenterZIP(documentId, fileName));
  };

  const breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_reportsRegistryPage'), href: paths.reportsRegistryPage }
  ];
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <div className="flex justify-between items-center">
          <h3>{t('reportsPage_registryReport')}</h3>
        </div>
        <div className="mt1">
          <StaticTablePagination
            columns={reportsRegistryColumn({
              t,
              onDownloadZip: handleDownloadZip,
              isFromReportPage: true,
            })}
            data={finCenterDocuments.content}
            sortable={false}
            totalElements={finCenterDocuments.totalElements}
            loading={loadingFinCenterDocuments}
            onClickLoadMore={() => nextPage()}
          />
        </div>
      </Paper>
    </>
  );
};

export default ReportsRegistryPage;
